export function getDisplayName(
  name: string | null | undefined,
  email?: string | null,
  fallback = 'Пользователь'
): string {
  const trimmed = name?.trim();
  if (trimmed) return trimmed;
  const localPart = email?.split('@')[0]?.trim();
  return localPart || fallback;
}

export function getFirstName(
  name: string | null | undefined,
  email?: string | null,
  fallback = 'коллега'
): string {
  const parts = getDisplayName(name, email, fallback).split(/\s+/).filter(Boolean);
  return parts[1] ?? parts[0] ?? fallback;
}
